
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierKnowledgeParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierKnowledgeParameters.ts

import {SupplierFamily } from "./SupplierFamily";
import {SupplierAnswer } from "./SupplierAnswer";
export class SupplierKnowledgeParameters {

  // int Id
  public Id: number=0;

  // SupplierFamily[] SupplierFamilies
  public SupplierFamilies: SupplierFamily[]=[];

  // string FamilyOther
  public FamilyOther?: string=null;

  // byte? TopWorkAtClient
  public TopWorkAtClient?: number=null;

  // DateTime? AccDatDeb
  public AccDatDeb?: Date=null;

  // DateTime? AccDatFin
  public AccDatFin?: Date=null;

  // int? NbEmployees
  public NbEmployees?: number=null;

  // int? NbWorkHours
  public NbWorkHours?: number=null;

  // int? NbWorkAccLostDays
  public NbWorkAccLostDays?: number=null;

  // int? NbWorkAccStop
  public NbWorkAccStop?: number=null;

  // int? NbWorkAccNoStop
  public NbWorkAccNoStop?: number=null;

  // decimal? TG
  public TG?: number=null;

  // decimal? TF1
  public TF1?: number=null;

  // decimal? TF2
  public TF2?: number=null;

  // SupplierAnswer[] SupplierAnswers
  public SupplierAnswers: SupplierAnswer[]=[];

  // int RefStep
  public RefStep: number=0;
}